import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import HeroSection from "./finance_hero.jsx";
import { useLang } from "../context/LangContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, 
  faCalendarDays, 
  faMoneyCheck ,
  faLanguage,
  faPhone } from "@fortawesome/free-solid-svg-icons";
  import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "../styles/finance.css";

export default function Finance() {
  const [content, setContent] = useState({});
  const { lang } = useLang();
  useEffect(() => {
    fetchPageContent("finance", lang).then(data => setContent(data));
  }, [lang]);

  const services = [
    content.finance_services,
    content.finance_services_1,
    content.finance_services_2,
    content.finance_services_3,
    content.finance_services_4,
    content.finance_services_5,
    content.finance_services_6,
    content.finance_services_7,
    content.finance_services_8,
    content.finance_services_9,
    content.finance_services_10,
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;

  return (
   <section className="finance-page">
     <div className="main-hero-section"><HeroSection/></div>
  

      <div className="finance-intro">
        {content.finance_about && ( 
        <p>{content.finance_about}</p>
        )}
        {content.finance_text_2 && ( 
        <p>{content.finance_text_2}</p>
        )}
      </div>
        
      <div className="finance-cards">
        {content.finance_text_4 && ( 
        <div className="finance-card">
          <FontAwesomeIcon icon={faClipboardList} className="finance-card-icon"/>
          <p>{content.finance_text_4}</p>
        </div>
         )}
       
        {content.finance_text_5 && (
        <div className="finance-card">
          <FontAwesomeIcon icon={faCalendarDays} className="finance-card-icon"/>
          <p>{content.finance_text_5}</p>
        </div>
          )}

          {content.finance_text_6 && (
        <div className="finance-card">
         <FontAwesomeIcon icon={faMoneyCheck} className="finance-card-icon"/>
          <p>{content.finance_text_6}</p>
        </div>
          )}
        {content.finance_text_1 && (
        <div className="finance-card">
          <FontAwesomeIcon icon={faLanguage} className="finance-card-icon"/>
          <p>{content.finance_text_1}</p>
        </div>
          )}
      </div>
      <div className="spacer"/>

      {content.finance_text_3 && (
       <div className="finance-intro">
        <p>{content.finance_text_3}</p> 
        </div>
      )}

      {/* Services List */}
     <div className="finance-services-section">
      <h2 className="finance-services-title">
        {content.finance_title_1}
        </h2>
       <div className="finance-services">
        {services.map((service, idx) => (
          <div key={idx} className="finance-service-item">
            ✔ {service}
          </div>
        ))}
      </div>
      </div>

      {/* Pricing Card */}
      {content.finance_price && (
      <div className="finance-pricing">
        {content.finance_price}
      </div>
      )}

      {content.finance_text_8 && (
      <div className="finance-intro">
        <p>{content.finance_text_8}</p> 
        </div>
      )}  

      {content.finance_text_9 && (
      <div className="finance-intro">
        <p>{content.finance_text_9}</p> 
        </div>
      )}  

      {content.finance_text_10 && (
      <div className="finance-intro">
        <p>{content.finance_text_10}</p> 
        </div>
      )}  

      {content.finance_text_7 && (
      <div className="finance-intro">
        <p>{content.finance_text_7}</p> 
        </div>
      )}  
      
        {content.finance_phone && (
        <div className="finance-bottom">
                  <div className="finance-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  /
                  <div className="finance-icon">
                  <FontAwesomeIcon icon={faWhatsapp} />
                  </div>
      <div >
         <a className="finance-contact" href={`tel:+${content.finance_phone}`}>+ {content.finance_phone}</a>
      </div>
      </div>
        )}
      <div className="spacer"/>
    
    </section>
    

  );

};